import type { CurrencyTypeEnum } from '@acme/api';
import { currencyStore } from '../model';
import type { Currency } from '../types';

type ApiCurrencyLike =
  | { id?: CurrencyTypeEnum; name?: string | null; code?: string | null }
  | null
  | undefined;

export const toCurrency = (currency: ApiCurrencyLike): Currency | null => {
  if (!currency) return null;
  const name = currency.name ?? '';
  const fromStore =
    currency?.id != null
      ? currencyStore.getCurrencyById(currency.id as CurrencyTypeEnum)
      : undefined;
  const symbol =
    fromStore?.code ??
    (currency && 'code' in currency ? currency.code : null) ??
    '';
  return {
    name,
    symbol: (symbol ?? '').trim() || '',
  };
};
